import { Version } from '@repo/toolkit/types'
import { PaginationResponse } from '@repo/ui/data-table'
import { PaginationRequest } from '@repo/ui/data-table'

import {
  TripBookingTypes,
  TripBookingVersionMap
} from '../../lib/types/models/trip-booking/trip-booking'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getTripBookings<
  T extends PaginationRequest<TripBookingTypes.Filters, Version> | undefined
>(input?: T) {
  type V = T extends { version: infer U extends Version } ? U : 'FULL'
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API['trip-bookings'].getAll.url, null), input))
    .get<PaginationResponse<TripBookingVersionMap[V]>>()
}
